var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repair"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/etc/logo.png")}}),_c('strong',[_vm._v("서비스를 점검중입니다.")]),_c('p',[_vm._v("잠시만 기다려주세요")])])])
}]

export { render, staticRenderFns }